import { listOnboardingProfileMissing } from '../utils/onboardingProfileGate';
import { countGoalTiers } from '../utils/trainingGoalTiers';
import { validatePersonalForSync } from '../utils/syncProfileBeforeOnboarding';

export const WIZARD_STEPS = {
  PROFILE: 'profile',
  PHYSICAL: 'physical',
  GOALS: 'goals',
  LIMITATIONS: 'limitations',
  PIPELINE: 'pipeline',
  REVIEW: 'review',
};

export const WIZARD_STEP_ORDER = [
  WIZARD_STEPS.PROFILE,
  WIZARD_STEPS.PHYSICAL,
  WIZARD_STEPS.GOALS,
  WIZARD_STEPS.LIMITATIONS,
  WIZARD_STEPS.PIPELINE,
  WIZARD_STEPS.REVIEW,
];

export const WIZARD_STEP_LABELS = {
  [WIZARD_STEPS.PROFILE]: 'Perfil',
  [WIZARD_STEPS.PHYSICAL]: 'Físico',
  [WIZARD_STEPS.GOALS]: 'Objetivos',
  [WIZARD_STEPS.LIMITATIONS]: 'Limitações',
  [WIZARD_STEPS.PIPELINE]: 'Geração',
  [WIZARD_STEPS.REVIEW]: 'Revisão',
};

export const MAX_REGENERATION_ROUNDS = 3;

export function parseWorkoutsPerWeek(value) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n >= 2 && n <= 4 ? n : null;
}

export function validateWizardStep(stepId, formData) {
  const errors = [];

  if (stepId === WIZARD_STEPS.PROFILE) {
    if (!formData?.level) errors.push('Selecione o nível.');
    const wpw = parseWorkoutsPerWeek(formData?.workoutsPerWeek);
    if (!wpw) errors.push('Informe entre 2 e 4 treinos por semana.');
  }

  if (stepId === WIZARD_STEPS.PHYSICAL) {
    try {
      validatePersonalForSync(formData);
    } catch (e) {
      errors.push(e.message || 'Dados físicos inválidos.');
    }
    const h = parseFloat(formData?.heightCm);
    const w = parseFloat(formData?.weightKg);
    if (!Number.isFinite(h) || h <= 0 || !Number.isFinite(w) || w <= 0) {
      errors.push('Altura e peso são obrigatórios.');
    }
  }

  if (stepId === WIZARD_STEPS.GOALS) {
    const n = countGoalTiers(formData?.trainingGoalTiers);
    const slugs = Array.isArray(formData?.trainingGoalSlugs) ? formData.trainingGoalSlugs.length : 0;
    if (n < 1 && slugs < 1) errors.push('Selecione pelo menos 1 objetivo.');
  }

  if (stepId === WIZARD_STEPS.LIMITATIONS) {
    const physical = String(formData?.physicalState || '').trim();
    const interests = String(formData?.trainingInterests || '').trim();
    if (physical.length < 10) errors.push('Estado físico: mínimo 10 caracteres.');
    if (interests.length < 20) errors.push('Interesses: mínimo 20 caracteres.');
  }

  return errors;
}

export function canEnqueueWizardJob(formData) {
  return listOnboardingProfileMissing(formData).length === 0;
}
